import { render, staticRenderFns } from "./RootTabelloneEsportaView.vue?vue&type=template&id=15ceda4f&"
import script from "./RootTabelloneEsportaView.vue?vue&type=script&lang=ts&"
export * from "./RootTabelloneEsportaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports